import { render, staticRenderFns } from "./KPITargetsDocs.vue?vue&type=template&id=21580a73&scoped=true"
import script from "./KPITargetsDocs.vue?vue&type=script&lang=js"
export * from "./KPITargetsDocs.vue?vue&type=script&lang=js"
import style0 from "./KPITargetsDocs.vue?vue&type=style&index=0&id=21580a73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21580a73",
  null
  
)

export default component.exports